import React, { Component } from "react";
import Button from "./buttons/Button";
import { Link } from "react-router-dom";
import styles from "../../assets/css/modules/shared/modal-popup.css";

export class ModalPopup extends Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
  }

  onBack(event) {
    event.preventDefault();
    this.props.cancel();
  }

  getContinueButtonId = () => {
    return this.props.continueButtonId
      ? this.props.continueButtonId
      : "continue-btn";
  };

  getContinueButtonLabel = () => {
    return this.props.continueButtonLabel
      ? this.props.continueButtonLabel
      : "continue";
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles.popup}>
          <button
            id="cancel-btn"
            type="button"
            className={
              "close axa-header-close align-self-center " + styles.crossBtn
            }
            aria-label="Cancel"
            onClick={() => this.props.cancel()}
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4>{this.props.heading}</h4>
          {this.props.description}

          <div className={styles.btnMargin + " row"}>
            <div className="col-sm-5 back-button">
              <p className="axa-body-text-4 mt-2">
                <Link id="backButton" to="" onClick={e => this.onBack(e)}>
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.backlink}
                </Link>
              </p>
            </div>
            <div className="col-sm-7 text-right">
              <Button
                label={this.getContinueButtonLabel()}
                onClick={() => this.props.continue()}
                buttonType="primaryOrangeButton"
                key={this.getContinueButtonLabel()}
                id={this.getContinueButtonId()}
                disabled={!!this.props.isButtonDisabled}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ModalPopup;
